module.exports = __webpack_public_path__ + "img/die.45a85e3c.png";